'use strict';

import angular from 'angular';


export default function() {
	'ngInject';

	const vm = this;

	function getAssignmentPolicies(allAssignments, assignment) {
		for (let _assignment of allAssignments) {
			if (assignment.id === _assignment.id) {
				return _assignment.tf_policies;
			}
		}
	}

	vm.processTemplate = function(allAssignments, reqs) {
		return reqs.map((_) => {
			return Object.assign({}, _, {
				target_membership_count: _.default_membership_count,
				assignment: Object.assign(_.assignment, {
					tf_policies: getAssignmentPolicies(allAssignments, _.assignment),
				}),
			});
		});
	};

	vm.flattenRequests = function(reqs) {
		return reqs.map((_) => {
			return {
				target_membership_count: _.target_membership_count,
				assignment_id: _.assignment.id,
				formation_policy_id: _.formation_policy.id,
			};
		});
	}
}
